import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-flight-result-loader',
  templateUrl: './flight-result-loader.component.html',
  styleUrls: ['./flight-result-loader.component.scss']
})
export class FlightResultLoaderComponent implements OnInit {
  list;

  constructor() {
    this.list = JSON.parse(localStorage.getItem('flightSearchParams')!);
  }

  ngOnInit(): void { }

}
